document.addEventListener('DOMContentLoaded', function(){

$('.video-blocks .videos').slick({
    dots: false,
    infinite: true,
    speed: 500, // Slower transition speed
    autoplay: false,
    autoplaySpeed: 10000,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0px',
    responsive: [
        {
            breakpoint: 480, // Targets mobile screens
            settings: {
                slidesToShow: 1, // Show only one slide on mobile
                arrows: false // Hide arrows if needed
            }
        }
    ]
});


  $('.testimonial-section').slick({
    dots: false,
    infinite: true,
    speed: 500, // Slower transition speed
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0px',
    responsive: [
        {
            breakpoint: 480, // Targets mobile screens
            settings: {
                slidesToShow: 1, // Show only one slide on mobile
                arrows: false // Hide arrows if needed
            }
        }
    ]
});

  
});






